<mat-form-field>
  <mat-select
    class="full-width"
    matInput
    [placeholder]="placeholder || 'Select Role'"
    [formControl]="formControl"
    (selectionChange)="ngOnChanges([])"
  >
    <mat-option *ngFor="let option of options" [value]="option">{{
      option | role
    }}</mat-option>
  </mat-select>
  <mat-error *ngIf="formControl.hasError('required')">
    Role is <strong>required</strong>
  </mat-error>
</mat-form-field>
